import React, {FC, useState} from 'react';
import styled, {css} from 'styled-components';

import {MultiViewResizerContainer} from './multiViewResizerContainer';
import {minimumMultiViewContentHeight} from './mutliViewHelpers';

/*
 * Props.
 */

interface MultiViewContentProps {
  index: number;
  shouldRenderPlaceholder: boolean;
  frameHeights: ReadonlyArray<number>;
}

/*
 * Style.
 */

interface StyledMultiViewContentProps {
  $flexHeight?: number;
}

const StyledMultiViewContentDiv = styled.div<StyledMultiViewContentProps>`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-auto-flow: column;
  border-radius: 8px;
  position: relative;
  background-color: ${(p) => p.theme.greys.white};
  filter: drop-shadow(0px 0px 1px ${(p) => p.theme.alphas.black50})
    drop-shadow(0px 3px 10px ${(p) => p.theme.alphas.black30});
  overflow: hidden;
  min-height: ${minimumMultiViewContentHeight}px;

  ${(p) => addFlexSpacingStyles(p.$flexHeight)}
`;

const StyledMultiViewContentPlaceholderDiv = styled.div<StyledMultiViewContentProps>`
  background: ${(p) => p.theme.greys.shade30};
  border: 1px dashed ${(p) => p.theme.greys.shade50};
  border-radius: 8px;
  min-height: ${minimumMultiViewContentHeight}px;

  ${(p) => addFlexSpacingStyles(p.$flexHeight)}
`;

function addFlexSpacingStyles(flexHeight?: number) {
  if (!flexHeight) {
    return css`
      flex: 1;
    `;
  }
  return css`
    flex: 0 0 ${flexHeight}%;
  `;
}

/*
 * Component.
 */

export const MultiViewContent: FC<MultiViewContentProps> = (props) => {
  const {index, shouldRenderPlaceholder, frameHeights, children} = props;
  const [flexHeight, setFlexHeight] = useState<number | undefined>(frameHeights[index]);

  const onSizeUpdate = (newHeight: number) => {
    setFlexHeight(newHeight);
  };

  return (
    <>
      {!shouldRenderPlaceholder && (
        <StyledMultiViewContentDiv $flexHeight={flexHeight}>{children}</StyledMultiViewContentDiv>
      )}
      {shouldRenderPlaceholder && <StyledMultiViewContentPlaceholderDiv $flexHeight={flexHeight} />}
      {index === 0 && <MultiViewResizerContainer onSizeUpdate={onSizeUpdate} />}
    </>
  );
};
